import { render, staticRenderFns } from "./PermissionRoleDetail.vue?vue&type=template&id=12c6d3ce&scoped=true&"
import script from "./PermissionRoleDetail.vue?vue&type=script&lang=js&"
export * from "./PermissionRoleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c6d3ce",
  null
  
)

export default component.exports